import { createAction } from '@reduxjs/toolkit';
import { actions as authActions } from './modules/auth/store/action'
import { actions as chatActions } from './modules/chat/store/action'
import { actions as taskActions } from './modules/task/store/action'
import { actions as userAction } from './modules/users/store/action'
import { actions as sitesAction } from './modules/sites/store/action'
import { actions as siteGroupAction } from './modules/siteGroup/store/action'
import { actions as propConfigAction } from './modules/propConfig/store/action'
import { actions as commonActions } from './modules/common/store/action'
import { actions as taskNotificationAction } from './modules/taskNotification/store/action'

const actionTypes = { ...authActions, ...chatActions, ...taskActions, ...userAction, ...sitesAction, ...propConfigAction, ...commonActions, ...siteGroupAction, ...taskNotificationAction} 


const appActions = {};

Object.entries(actionTypes).forEach(([key, value]) => {
    appActions[key] = createAction(value);
});

export default appActions;
